import { breakpoints } from './breakpoints';
import { components } from './components';
import { typography } from './typography';

export * from './colors';
export const commonThemeConfig = {
    breakpoints,
    components,
    typography,
};
